<template>
    <div class="dock-item"
         :class="{'dock-item--active': active, 'dock-item--bouncing': bounceType === 'open', 'dock-item--bouncing-attention': bounceType === 'attention', 'dock-item--minimized': minimized, 'dock-item--dragging': dragging, 'dock-item--shift-left': dragShift === 'left', 'dock-item--shift-right': dragShift === 'right'}"
         @click="onClick"
         @contextmenu.prevent.stop="$emit('contextmenu', $event)"
         @pointerdown="onPointerDown">
        <div class="dock-item-icon" :class="{'dock-item-icon--colored': !!color}" :style="iconStyle" @animationend="bounceType = null">
            <slot>
                <span v-html="icon"></span>
            </slot>
        </div>
        <div class="dock-item-tooltip"><span class="dock-item-tooltip-arrow"></span>{{ label }}</div>
        <div class="dock-item-indicator" :class="{'dock-item-indicator--visible': active || minimized}"></div>
    </div>
</template>

<script>
export default {
    name: 'DockItem',
    props: {
        icon: {type: String, default: ''},
        label: {type: String, default: ''},
        color: {type: String, default: ''},
        active: {type: Boolean, default: false},
        minimized: {type: Boolean, default: false},
        isDraggable: {type: Boolean, default: false},
        dragging: {type: Boolean, default: false},
        itemIndex: {type: Number, default: -1},
        section: {type: String, default: ''},
        dragShift: {type: String, default: ''},
        clickAnimationEnabled: {type: Boolean, default: true},
    },
    emits: ['click', 'contextmenu', 'pointer-down'],
    data() {
        return {bounceType: null}
    },
    methods: {
        triggerBounce(type) {
            this.bounceType = null
            void this.$el?.offsetHeight
            this.bounceType = type || 'open'
        },
        onClick(e) {
            if (this._skipClick) { this._skipClick = false; return }
            if (this.clickAnimationEnabled) this.triggerRipple(e)
            this.$emit('click')
        },
        onPointerDown(e) {
            if (!this.isDraggable || e.button !== 0) return
            this.$emit('pointer-down', {index: this.itemIndex, section: this.section, event: e})
        },
        suppressNextClick() {
            this._skipClick = true
        },
        triggerRipple() {
            const iconEl = this.$el?.querySelector('.dock-item-icon')
            if (!iconEl) return
            iconEl.animate(
                [{filter: 'brightness(1.5)'}, {filter: 'brightness(1)'}],
                {duration: 300, easing: 'ease-out'}
            )
            const itemEl = this.$el
            const iconRect = iconEl.getBoundingClientRect()
            const itemRect = itemEl.getBoundingClientRect()
            const cx = iconRect.left + iconRect.width / 2 - itemRect.left
            const cy = iconRect.top + iconRect.height / 2 - itemRect.top
            const size = iconRect.width
            const color = this.color || 'rgba(120,120,120,0.8)'
            const wave = document.createElement('span')
            wave.style.cssText =
                'position:absolute;border-radius:50%;pointer-events:none;' +
                'width:' + size + 'px;height:' + size + 'px;' +
                'left:' + (cx - size / 2) + 'px;top:' + (cy - size / 2) + 'px;' +
                'background:radial-gradient(circle,' + color + ' 0%,' + color + ' 40%,transparent 100%);' +
                'filter:blur(8px);'
            itemEl.appendChild(wave)
            wave.animate(
                [{transform: 'scale(0.6)', opacity: 1}, {transform: 'scale(3)', opacity: 0}],
                {duration: 550, easing: 'ease-out'}
            ).onfinish = () => wave.remove()
        },
    },
    computed: {
        iconStyle() {
            if (!this.color) return {}
            return {background: this.color}
        },
    },
}
</script>
